mutation UpdateAmendedPledge($amendedPledgeId: ID!, $countersigned: Boolean!) {
  updateAmendedPledge(
    input: { amendedPledgeId: $amendedPledgeId, countersigned: $countersigned }
  ) {
    amendedPledge {
      id
      companyName
      currentPercentage
      dateSigned
      countersigned
      shareholdingPercentage
      valuation
    }
  }
}
